import React from "react";
import "./Help.css";
import { FaWheelchair, FaClock, FaSmokingBan, FaDog } from "react-icons/fa";

const HelpPropertyPolicies = () => {
  return (
    <section className="helpSection p-3">
      <div className="container-xl">
        <div className="helpHeader mb-4">
          <h2 className="fw-bold text-dark">Property Policies</h2>
          <p className="text-muted">
            Learn about check-in/out timings, pet and smoking policies, and facilities at YOVHO properties.
          </p>
        </div>

        <div className="helpContent">
          {/* 1 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaWheelchair />
            </div>
            <div className="helpText">
              <h5>Guests with Assistance Animals</h5>
              <p>
                Travelers with assistance animals are welcome at verified YOVHO properties. They can stay without extra fees or special conditions even if pets are generally not allowed.
                Always inform your host or YOVHO captain in advance for proper arrangements.
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaClock />
            </div>
            <div className="helpText">
              <h5>Check-In and Check-Out Timings</h5>
              <p>
                Each property has its own check-in and check-out schedule. You can view these under “House Rules” on the property page.
                After confirming your stay, the exact timings are also in your confirmation email and YOVHO account.
              </p>
            </div>
          </div>

          {/* 3 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaClock />
            </div>
            <div className="helpText">
              <h5>Late or Early Check-Out / Check-In</h5>
              <p>
                If you want early or late check-in/out, request it when booking, via your YOVHO account, or contact the property directly. 
                Approval depends on availability, but hosts usually try to accommodate requests. Always confirm in advance for remote locations or late-night arrivals.
              </p>
            </div>
          </div>

          {/* 4 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaSmokingBan />
            </div>
            <div className="helpText">
              <h5>Smoking Policy</h5>
              <p>
                Non-smoking rooms indicate that smoking is not allowed inside. Some properties may have designated outdoor smoking areas — check with the host or captain for details.
              </p>
            </div>
          </div>

          {/* 5 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaDog />
            </div>
            <div className="helpText">
              <h5>Pet Policy</h5>
              <p>
                Each property’s pet policy is shown under “House Rules.” Only verified properties meeting YOVHO’s family-friendly and hygiene standards are listed.
                You’ll always know whether pets are allowed before booking.
              </p>
            </div>
          </div>

          {/* 6 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaWheelchair />
            </div>
            <div className="helpText">
              <h5>Facilities Information</h5>
              <p>
                Check the “Facilities” section on each property page to see what is available — from parking and Wi-Fi to family features and nearby attractions. This helps you compare options before booking.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HelpPropertyPolicies;
